import { Routes } from '@angular/router';
import { AuthComponent } from './core/auth/auth.component';
import {  MainLayoutComponent } from './layouts/mainLayout/main-layout.component';
import { guards } from './core/guards';
import { DevicesComponent } from './features/bots/bots.component';
import { Cockpit } from './features/cockpit/cockpit.component';
import { CockpitDesigner } from './features/cockpitDesigner/cockpitDesigner.component';

export const routes: Routes = [ 
  {path: 'auth', component: AuthComponent, canActivate: [guards.isAuthenticatedGuard]},
  {
    path:'',
    canActivate:[guards.AuthGuard, guards.DeviceGuard],
    component: MainLayoutComponent,
    children: [
      {
        path:'devices',
        component: DevicesComponent
      },
      {
        path:'cockpit',
        component: Cockpit,
        canActivate:[]
      },
      {
        path:'cockpit-designer',
        component: CockpitDesigner,
      }
    ]
  },
];
